import createInstance from '../http';
import config from '@/const/config';
const { request } = createInstance(config.agreementBaseUrl);

export default {
  queryUserAgreementSignStatus: params => request.post(`/api/agreement/1.0.0/query_user_agreement_sign_status`, params), // 买家协议签署状态
  signAgreement: params => request.post(`/api/agreement/1.0.0/sign_agreement`, params) // 买家协议签署
};
